import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import '../styles/Root.css';
import logomusee from '../assets/logomusee.png'

const Header = () => {
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [activeSubmenu, setActiveSubmenu] = useState(null);
  const navMenuRef = useRef(null);
  const hamburgerRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuActive(!isMenuActive);
  };

  const handleMouseEnter = (submenuRef) => {
    if (window.innerWidth > 1024) {
      if (activeSubmenu && activeSubmenu !== submenuRef) {
        activeSubmenu.classList.remove('active');
      }
      submenuRef.classList.add('active');
      setActiveSubmenu(submenuRef);
    }
  };

  const handleMouseLeave = (submenuRef) => {
    if (window.innerWidth > 1024) {
      submenuRef.classList.remove('active');
      setActiveSubmenu(null);
    }
  };

  const handleSubmenuClick = (e, submenuRef) => {
    if (window.innerWidth <= 1024) {
      e.preventDefault();
      if (activeSubmenu && activeSubmenu !== submenuRef) {
        activeSubmenu.classList.remove('active');
      }
      submenuRef.classList.toggle('active');
      setActiveSubmenu(submenuRef.classList.contains('active') ? submenuRef : null);
    }
  };

  const handleOutsideClick = useCallback((e) => {
    const clickedOutsideMenu = !navMenuRef.current.contains(e.target) && !hamburgerRef.current.contains(e.target);

    if (clickedOutsideMenu) {
      setIsMenuActive(false);
      if (activeSubmenu) {
        activeSubmenu.classList.remove('active');
        setActiveSubmenu(null);
      }
    }
  }, [activeSubmenu]);

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setIsMenuActive(false);
        if (activeSubmenu) {
          activeSubmenu.classList.remove('active');
          setActiveSubmenu(null);
        }
      }
    };
    window.addEventListener('resize', handleResize);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
      window.removeEventListener('resize', handleResize);
    };
  }, [handleOutsideClick, activeSubmenu]);

  return (
    <nav className="nav-tdm">
      <div className="nav-mobile">
        <button
          ref={hamburgerRef}
          className={`hamburger ${isMenuActive ? 'active' : ''}`}
          aria-label="Menu"
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      <div className="nav-logo">
        <Link to="/">
          <img src={logomusee} alt="Logo Musée des Troupes de Marine" />
        </Link>
      </div>
      <ul ref={navMenuRef} className={`nav-menu ${isMenuActive ? 'active' : ''}`}>
        <li className="nav-item has-submenu">
          <Link
            to="#"
            className="nav-link"
            onClick={(e) => handleSubmenuClick(e, document.querySelector('.nav-item:nth-child(1) .submenu'))}
          >
            Le Musée
          </Link>
          <ul
            className="submenu"
            onMouseEnter={() => handleMouseEnter(document.querySelector('.nav-item:nth-child(1) .submenu'))}
            onMouseLeave={() => handleMouseLeave(document.querySelector('.nav-item:nth-child(1) .submenu'))}
          >
            <li><Link to="/pages/LeMuseeEnBref">Le musée en bref</Link></li>
            <li><Link to="/pages/SesCollections">Ses collections</Link></li>
            <li><Link to="/pages/LeChetom">Le CHETOM</Link></li>
            <li><Link to="/pages/TravaillerAuMusee">Travailler au musée ?</Link></li>
            <li><Link to="/pages/NosPartenaires">Ses Partenaires</Link></li>
          </ul>
        </li>
        <li className="nav-item has-submenu">
          <Link to="/pages/LaBoutique" className="nav-link">La Boutique</Link>
        </li>
        <li className="nav-item has-submenu">
          <Link
            to="#"
            className="nav-link"
            onClick={(e) => handleSubmenuClick(e, document.querySelector('.nav-item:nth-child(3) .submenu'))}
          >
            Les Amis du Musée
          </Link>
          <ul
            className="submenu"
            onMouseEnter={() => handleMouseEnter(document.querySelector('.nav-item:nth-child(3) .submenu'))}
            onMouseLeave={() => handleMouseLeave(document.querySelector('.nav-item:nth-child(3) .submenu'))}
          >
            <li><Link to="/pages/SesMissions">Ses missions</Link></li>
            <li><Link to="/pages/SesConferences">Ses conférences</Link></li>
            <li><Link to="/pages/DevenirAdherent">Devenir adhérent</Link></li>
            <li><Link to="/pages/Login">Espace adhérent</Link></li>
          </ul>
        </li>
        <li className="nav-item has-submenu">
          <Link
            to="#"
            className="nav-link"
            onClick={(e) => handleSubmenuClick(e, document.querySelector('.nav-item:nth-child(4) .submenu'))}
          >
            Les Actualités
          </Link>
          <ul
            className="submenu"
            onMouseEnter={() => handleMouseEnter(document.querySelector('.nav-item:nth-child(4) .submenu'))}
            onMouseLeave={() => handleMouseLeave(document.querySelector('.nav-item:nth-child(4) .submenu'))}
          >
            <li><Link to="/pages/ActualitesMusee">Du Musée</Link></li>
            <li><Link to="/pages/ActualitesAAMTDM">De l'AAMTDM</Link></li>
          </ul>
        </li>
        <li className="nav-item has-submenu">
          <Link
            to="#"
            className="nav-link"
            onClick={(e) => handleSubmenuClick(e, document.querySelector('.nav-item:nth-child(5) .submenu'))}
          >
            Contacts
          </Link>
          <ul
            className="submenu"
            onMouseEnter={() => handleMouseEnter(document.querySelector('.nav-item:nth-child(5) .submenu'))}
            onMouseLeave={() => handleMouseLeave(document.querySelector('.nav-item:nth-child(5) .submenu'))}
          >
            <li><a href="tel:+33494407605">Téléphone</a></li>
            <li><Link to="/pages/FormulairesContact">Formulaires de contact</Link></li>
          </ul>
        </li>
        <li className="nav-item has-submenu">
          <Link
            to="#"
            className="nav-link"
            onClick={(e) => handleSubmenuClick(e, document.querySelector('.nav-item:nth-child(6) .submenu'))}
          >
            Préparer ma visite
          </Link>
          <ul
            className="submenu"
            onMouseEnter={() => handleMouseEnter(document.querySelector('.nav-item:nth-child(6) .submenu'))}
            onMouseLeave={() => handleMouseLeave(document.querySelector('.nav-item:nth-child(6) .submenu'))}
          >
            <li><Link to="/pages/InformationsPratiques">Informations pratiques</Link></li>
            <li><Link to="/pages/VisiteGuidee">Demander une visite guidée</Link></li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
